import {useMutation} from "@tanstack/react-query";
import {API} from "../../api";

export const useUpdateFeatureMutation = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (params) => {
      const {enabled, key, role} = params;
      return API.updateFeatureFlag(key, role, {enabled});
    },
    onSuccess,
    onError: (err) => {
      if (onError) {
        onError(err);
      }
      console.error(err);
    },
  });
};
